import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router'
import Cookie from '../components/common/Cookie'
import Coop from '../components/common/CoopPop'
import CursorBall from '../components/common/CursorBall'
import ScrollToTop from '../components/common/ScrollToTop'
import Header from '../components/Header'
import LocaleMenu from '../components/LocaleMenu'
import Menu from '../components/Menu'
import CountriesBurger from '../components/pages/about/CountriesBurger'
import FullPage from '../components/pages/about/FullPage'
import Preloader from '../components/Preloader'
import VideoBox from '../components/VideoBox'
import useLocoScroll from '../hooks/useLoco'
import changeLocaleByPath from '../mocks/changeLocale'
import ContentState, {
  getAboutContent,
  getCoopContent,
  getFooter,
  getHomeContent,
  getMenu,
  getSubMenu,
} from '../stores/ContentState'
import GlobalState, { setLang, watchVideo } from '../stores/GlobalState'

const AboutPage = observer(() => {
  const [loading, setLoading] = useState(true)
  const ref = useRef<any>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const { pathname } = useLocation()
  useEffect(() => {
    changeLocaleByPath(pathname)
    setLang()
    getMenu()
    getSubMenu()
    getFooter()
    getHomeContent()
    getAboutContent().then(() => {
      setTimeout(() => {
        setLoading(false)
      }, 200)
    })
    getCoopContent()
    return () => {
      setLoading(true)
    }
  }, [])
  useEffect(() => {
    if (!loading) {
      if (typeof window === 'undefined' || !window.document) {
        return
      }
    }
  }, [loading])

  useEffect(() => {
    if (loading) return
    document.querySelector('#root')?.classList.add('auto')
    document.querySelector('#root')?.classList.add('visible')
    document.querySelector('html')?.classList.add('auto')
    document.querySelector('#root')?.classList.add('about-page')
    document.querySelector('body')?.classList.add('auto')

    return () => {
      document.querySelector('#root')?.classList.remove('visible')
    }
  }, [loading])

  useEffect(() => {
    window.addEventListener('keydown', function (event: any) {
      if (
        event.ctrlKey == true &&
        (event.which == '61' ||
          event.which == '107' ||
          event.which == '173' ||
          event.which == '109' ||
          event.which == '187' ||
          event.which == '189')
      ) {
        event.preventDefault()
      }

      if (
        event.which != '86' &&
        event.which != '67' &&
        event.metaKey &&
        event.which != 65
      ) {
        event.preventDefault()
      }
    })

    window.addEventListener('mousewheel DOMMouseScroll', function (event: any) {
      if (event.ctrlKey == true) {
        event.preventDefault()
      }
    })
  }, [])

  useEffect(() => {
    setTimeout(() => {
      window.addEventListener('scroll', (e) => {
        const header = document.querySelector('.header')

        if (!header) return
        if (window.scrollY > header?.getBoundingClientRect().height / 4) {
          header.classList.add('header-hidden')
        } else {
          header.classList.remove('header-hidden')
        }
      })
    }, 100)
  }, [])

  useEffect(() => {
    if (GlobalState.isCoopShow) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isCoopShow])

  if (typeof window === 'undefined' || !window.document) {
    return <></>
  }

  if (!ContentState.about) return <></>
  return (
    <>
      <div ref={ref}></div>
      <ScrollToTop headerContent={ref} />
      {/* <Preloader loading={loading} /> */}
      <Header />
      <Cookie />
      {!loading && (
        <div
          className="smooth"
          data-scroll
          ref={containerRef}
          data-load-container
        >
          <div
            className={classNames(
              'container smooth-scroll',
              loading && 'hidden',
              !loading && 'visible',
            )}
          >
            <FullPage />
          </div>
        </div>
      )}
      <VideoBox
        src={GlobalState.video.src}
        poster={GlobalState.video.poster}
        setShow={() =>
          watchVideo(GlobalState.video.src, GlobalState.video.poster)
        }
      />
      <CountriesBurger />

      <Menu />
      <LocaleMenu />
      {/* <CursorBall/> */}
      {GlobalState.isCoopShow && <Coop />}
      <div
        className={classNames('menu__bg', GlobalState.isMenuOpen && 'show')}
      ></div>
      <div
        className={classNames('menu__bg', GlobalState.isLocaleOpen && 'show')}
      ></div>
    </>
  )
})

export default AboutPage
